/**
 * Enum for filtering users by their onboarding status
 */
export enum UserOnboardingStatusFilter {
	CONFIRMED_CONTRIBUTING = 'CONFIRMED_CONTRIBUTING',
	BENEFIT_REJECTED = 'BENEFIT_REJECTED',
	// Empleados de baja (backend filtra por employmentStatus=TERMINATED)
	NOT_ACTIVE_IN_ARCA_OR_EMPLOYMENT_STATUS_NOT_CURRENTLY_EMPLOYED = 'NOT_ACTIVE_IN_ARCA_OR_EMPLOYMENT_STATUS_NOT_CURRENTLY_EMPLOYED'
}

const findParticipantsContributionData = async (
	token: string,
	page: number,
	limit: number,
	year: number,
	statusFilter?: UserOnboardingStatusFilter | null,
	companyId?: string | null,
	search?: string | null
) => {
	const body: {
		page: number;
		limit: number;
		year: number;
		statusFilter?: UserOnboardingStatusFilter | null;
		companyId?: string;
		search?: string;
	} = { page, limit, year };

	if (statusFilter) body.statusFilter = statusFilter;
	if (companyId) body.companyId = companyId;
	if (search) body.search = search;

	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/calculators/participants-contributions`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(body)
		}
	);

	return response.json();
};

export default findParticipantsContributionData;
